import type { ButtonComponentProps } from '@timelyapp/react';
import { useButtonClassNames } from '@timelyapp/react';
import classNames from 'classnames';
import type { AnchorHTMLAttributes } from 'react';
import React from 'react';
import { NavLink } from 'react-router-dom';

export interface AppLinkButtonProps
  extends Omit<ButtonComponentProps, 'selected' | 'caret'>,
    AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: React.ReactNode;
  linkTo: string;
  replace?: boolean;
}

const AppLinkButton: React.FC<AppLinkButtonProps> = props => {
  const { className } = useButtonClassNames(props);
  const { disabled, onClick, isActive, linkTo, destructive, children, ...rest } = props;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      // Links don't have a "disabled" property, so we preventDefault when clicked
      // so it mimicks the behavior of actual buttons.
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  const wrappedChildren = typeof children === 'string' ? <span>{children}</span> : children;

  return (
    <NavLink
      {...rest}
      to={linkTo}
      data-act-as-button
      className={classNames(className, props.className)}
      onClick={handleClick}
    >
      {wrappedChildren}
    </NavLink>
  );
};
export default AppLinkButton;
